import { useEffect, useLayoutEffect, useState } from "react";
import { getAllSaveplaces, saveItemAPI } from "../apis/SavePlaces";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setAllSavedItems } from "../redux/action";
import { toast } from "react-toastify";

export const useSavedPlacesHooks = () => {
  //all local states
  const allSavedItems=useSelector((s)=>s?.allSavedItems??[],shallowEqual);
  const dispatch=useDispatch();
  let defaultTypes={event:"event",place:"place",commercial:"commercial"};
  //all useEffect


const handleSavePlace=(item)=>{
console.log("Saving .......",item);
let data=saveItemAPI(defaultTypes?.place,item?._id);

  dispatch(setAllSavedItems([item,...allSavedItems]));
  toast.success("Place saved successfully !");


}


  useEffect(() => {
    console.log("called");

    const getAllRecentlySavedApi = () => {
      getAllSaveplaces({}).then((res) => {
        let places = res?.places?.map((i) => typeof i === "object" ? { ...i, displayType: "place" } : i) ?? [];
        let events = res?.events?.map((i) => typeof i === "object" ? { ...i, displayType: "event" } : i) ?? [];
        let commercials = res?.commercials?.map((i) => typeof i === "object" ? { ...i, displayType: "commercial" } : i) ?? [];
       dispatch( setAllSavedItems([...places, ...events, ...commercials]))


      });
    };
    if(allSavedItems?.length===0)
    getAllRecentlySavedApi();
  }, []);

  //all functions

  return {allSavedItems,handleSavePlace};
};
